/* eslint-disable no-console */
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { requestWithStatusHandling } from './api-status-handler';

export const addProductCard = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_CP.ADD_UPDATE_CP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchAllProductCards = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_CP.GET_PRODUCT_CP}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchProductDetail = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_CP.GET_INDIVIDUAL_DETAILS}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteProductCP = async (params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_CP.DELETE_PRODUCT_CP}`, {
      ...params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const duplicateProductCard = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_CP.DUPLICATE_PRODUCT_CP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addProductCpTabsService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_CP.ADD_UPDATE_PRODUCTCP_TABS}`, { tabs: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllProductcpTabsService = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_CP.GET_PRODUCTCP_TABS}/${params.productCPId}`, {
      params: { fromDetails: !!params?.fromDetails },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addColumnsToProductCpCardService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_CP.ADD_UPDATE_COLUMNS_IN_PCP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteTabsColumnsService = async (params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_CP.DELETE_PRODUCT_CP_COLUMNS}`, {
      ...params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const activeInactiveActionService = async (params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_CP.ACTIVE_INACTIVE_COLUMNS}`, {
      ...params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchDynamicTabColumnDetails = async (data) => {
  return requestWithStatusHandling(apiClient, {
    method: 'post',
    url: `${apiEndpoint}${API.PRODUCT_CP.GET_DYNAMIC_COLUMN_DETAILS}`,
    data: { ...data },
  });
};

export const fetchSourceColumnStats = async (data) => {
  return requestWithStatusHandling(apiClient, {
    method: 'post',
    url: `${apiEndpoint}${API.PRODUCT_CP.SOURCE_COLUMN_STATS}`,
    data: { ...data },
  });
};

export const updatePCPDetailBySupplier = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_CP.UPDATE_DETAIL_BY_SUPPLIER}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const manualDataAdded = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_CP.SAVE_MANUAL_DETAILS}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const manualDataAddedPO = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_CP.SAVE_MANUAL_DETAILS_PO}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// rearange tab changes in product cp
export const rearrangeTabChanges = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_CP.REARRANGE_PRODUCT_CP_TABS}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

//  delete tabs from PCP
export const deleteTabsPCP = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.PRODUCT_CP.DELETE_PRODUCTCP_TABS}`, { data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// get all verified suppliers
export const fetchAllVerifiedSuppliers = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_CP.GET_VERIFIED_SUPPLIERS}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const downloadPCPExcelService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_CP.PCP_EXCEL_SHEET_DOWNLOAD}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getPCPLogs = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_CP.GET_PRODUCTCP_LOGS}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deletePCPLogs = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.PRODUCT_CP.GET_PRODUCTCP_LOGS}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// bulk update product cp
export const bulkUpdateServices = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_CP.BULK_UPDATE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const pinUnpinTabColum = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_CP.PIN_UNPIN_COLUMN}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTabColumn = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_CP.ADD_UPDATE_COLUMNS_IN_PCP}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchColumnFilter = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_CP.COLUMN_OPTIONS}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getPCPUploadPresignedUrl = async (pcpId, fileName) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_CP.PCP_PRESIGNED_URL}`, {
      pcpId,
      fileName,
    });
  } catch (error) {
    console.error('getPCPUploadPresignedUrl error:', error);
    throw error;
  }
};

export const getPCPProductUploadPresignedUrl = async (pcpId, fileName) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_CP.PCP_PRESIGNED_URL_PRODUCT}`, {
      pcpId,
      fileName,
    });
  } catch (error) {
    console.error('getPCPProductUploadPresignedUrl error:', error);
    throw error;
  }
};

export const uploadFileToS3Direct = async (presignedUrl, file) => {
  try {
    const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
    const contentType = fileExtension === '.xlsx' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/vnd.ms-excel';

    const response = await fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': contentType,
        'Content-Length': file.size.toString(),
      },
    });

    if (response.ok) {
      return { success: true };
    }

    const errorText = await response.text().catch(() => 'No error details');
    console.error('S3 upload failed:', {
      status: response.status,
      statusText: response.statusText,
      error: errorText,
    });

    throw new Error(`Upload failed with status: ${response.status} - ${response.statusText}`);
  } catch (error) {
    console.error('uploadFileToS3Direct error:', error);
    return { success: false, error: error.message };
  }
};
